import { useRouter } from 'vue-router';

import type { ApiTabValueType } from './types';

export default function useApiRoutes() {
  const router = useRouter();

  function openTab(tab: ApiTabValueType) {
    return router.push({ name: 'api', params: { tab } });
  }

  function openCreate(tab: ApiTabValueType) {
    return router.push({ name: 'api_create', params: { tab } });
  }

  function openDetail(
    tab: ApiTabValueType,
    id: string,
    { replace = false }: { replace?: boolean } = {},
  ) {
    const location = { name: 'api_detail', params: { tab, id } };
    return replace ? router.replace(location) : router.push(location);
  }

  /**
   * Pushing the tab on close leaves the overlay one Back away, so Back would
   * reopen it. Go back when there is somewhere to go, and on a deep link swap
   * the overlay entry for the tab instead.
   */
  function closeOverlay(tab: ApiTabValueType) {
    if (window.history.state?.back) return router.back();
    return router.replace({ name: 'api', params: { tab } });
  }

  return { openTab, openCreate, openDetail, closeOverlay };
}
